import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { selectUploadFiles, toggleUploadDispatchBox, startUpload, showUploadsTray, switchResumable } from 'signoxe/actions';
import PopupCustom from 'signoxe/components/PopupCustom';
import { getUploadDispatchState, getUploadTrayOpen } from '../../selectors';
import './styles.scss';

class UploadDispatch extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      data: {
        choice: {},
        type: 'fresh',
        id: Math.random().toString(10).substr(2,20)
      },
      visible: false
    }
  }

  static propTypes = {
    uploadDispatch: PropTypes.object.isRequired,
    visible: PropTypes.bool.isRequired,
  }

  handleSelect(){}

  componentDidMount(){
    const { choice, single, visible } = this.props.uploadDispatch
    if (Object.entries(single).length !== 0){
      // this.props.toggleUploadDispatchBox()
      this.props.switchResumable()
      this.props.showUploadsTray()
      this.props.startUpload({...this.state.data, choice: single})
    }
    else if (Object.entries(choice).length !== 0){

      this.props.switchResumable()
      this.props.showUploadsTray()
      this.props.startUpload({...this.state.data, ...choice, type: 'resume'})
    }
  }

  render(){
    const { visible, single, choice } = this.props.uploadDispatch

    return (
      <PopupCustom visible={visible} title="Upload">
        <div>
          Just making sure that shit works
          <button type="btn" onClick={this.props.toggleUploadDispatchBox}>Click to remove</button>
        </div>
      </PopupCustom>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    uploadDispatch: getUploadDispatchState(state),
    uploadTrayOpen: getUploadTrayOpen(state),
  };
};

export default connect(mapStateToProps, {
  selectUploadFiles, toggleUploadDispatchBox, startUpload, showUploadsTray,
  switchResumable
})(UploadDispatch)



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/UploadDispatch/index.js